module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/iPhone-X-d05efc0c350d998a6809d795aa4358b0.svg";